import BaseComponent from "../../../baseComponent.js";
import SearchBox from "./searchBox.jsx";
import PageableList from "./pageableList.jsx";
import Filter from "./filter.jsx";
import FunctionService from "../../../../core/services/functionService.js";
import DataSetService from "../../../../core/services/datasetService.js";
import styles from "./styles.scss";
import InternalEvent from "../../../../core/constants/internalEvent.js";

export default class AddWidgetSearch extends BaseComponent {
  constructor(props) {
    super(props);
      this.state = {
        searchString: "",
        datasets: [],
        functions: [],
        filterTypeIndex: 0
    }
  }

  componentDidMount() {

  }

  componentWillUmount(){

  }

  onSearchValueChange(searchString, filterIndex) {
    var _this = this;
    var ss = searchString.trim();
    filterIndex = filterIndex == null ? this.state.filterTypeIndex : filterIndex;

    var pageSize = $(".add-widget-search").find(".pageable-list").height() / 45;

    // reset paging for the new search
    this.pagination = {
      pageNumber: 1,
      pageSize: pageSize > 15 ? pageSize : 15,
      isLastPage: false
    };

    if (ss === "") {
      this.setState({
        filterTypeIndex: filterIndex,
        searchString: "",
        datasets: []
      });
      this.forceUpdate();
      return;
    }
    else if (filterIndex === 2) {
      FunctionService.getFunctionsByName(searchString).then((response) => {
        _this.setState({
          filterTypeIndex: filterIndex,
          searchString: ss,
          functions: response.data
        });
        _this.forceUpdate();
      });
      this.setState({
        filterTypeIndex: filterIndex,
        searchString: ss,
        datasets: []
      });
      this.forceUpdate();
    }
    else if (filterIndex === 1) {
      DataSetService.getOnlyUnsubscribedDataSetsByName(searchString, this.pagination).then(datasets => {
        this.pagination.isLastPage = datasets.length < 15;
        this.setState({
          filterTypeIndex: filterIndex,
          searchString: ss,
          datasets: datasets
        });
        _this.forceUpdate();
      });
      this.setState({
        filterTypeIndex: filterIndex,
        searchString: ss,
        datasets: []
      });
      this.forceUpdate();
    }
    else if (filterIndex === 0) {
      DataSetService.getOnlySubscribedDataSetsByName(searchString, this.pagination).then(datasets => {
        this.pagination.isLastPage = datasets.length < 15;
        this.setState({
          filterTypeIndex: filterIndex,
          searchString: ss,
          datasets: datasets
        });
        _this.forceUpdate();
      });
      this.setState({
        filterTypeIndex: filterIndex,
        searchString: ss,
        datasets: []
      });
      this.forceUpdate();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.searchString !== nextState.searchString;
  }

  findDatasets(index) { //index select
    var _this = this;
    if (this.onProgress) return;
    if (this.pagination.isLastPage || this.state.searchString === "") return;

    $(this.refs.preloader).velocity("slideDown", {duration: 50});


    var pagingOption = {
      pageNumber: ++this.pagination.pageNumber,
      pageSize: 15
    };

    this.onProgress = true;
    if(index == 1){
      DataSetService.getOnlyUnsubscribedDataSetsByName(this.state.searchString, pagingOption)  //choose  query
        .then(datasets => {
          this.pagination.isLastPage = datasets.length < 15;

          if (datasets.length > 0) {
            var concatedDatasets = _this.state.datasets.concat(datasets);
            this.setState({
              datasets: concatedDatasets
            });

            // TODO: somehow, setState won't trigger update. for now force updating
            this.forceUpdate();
          }

          this.onProgress = false;

          $(this.refs.preloader).velocity("slideUp", {duration: 50});
        });
    }
    else if(index == 0){
      DataSetService.getOnlySubscribedDataSetsByName(this.state.searchString, pagingOption)  //choose  query
        .then(datasets => {
          this.pagination.isLastPage = datasets.length < 15;

          if (datasets.length > 0) {
            var concatedDatasets = _this.state.datasets.concat(datasets);
            this.setState({
              datasets: concatedDatasets
            });

            // TODO: somehow, setState won't trigger update. for now force updating
            this.forceUpdate();
          }

          this.onProgress = false;

          $(this.refs.preloader).velocity("slideUp", {duration: 50});
        });
    }
  }

  handleFilterChange(index) {
    this.props.indexValue(index);
    this.onSearchValueChange(this.state.searchString, index);
  }

  render() {
    return (
      <div className={styles.addWidgetSearch}>
        <SearchBox onUserInput={this.onSearchValueChange}/>
        <Filter typeIndex={this.state.filterTypeIndex} onFilterChange={this.handleFilterChange}/>
        <PageableList widgetType={this.props.widgetType}
                      datasets={this.state.datasets}
                      functions={this.state.functions}
                      typeIndex={this.state.filterTypeIndex}
                      nextPage={this.findDatasets}/>
        <div className={styles.verticalLine}></div>
        <div className={["progress", styles.progress].join(" ")} ref="preloader">
          <div className="indeterminate"></div>
        </div>
      </div>
    );
  }
}











// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/search/addWidgetSearch.jsx